// The (i) beside a short line: where the longer explanation lives.
//
// The text is always in the document, visually hidden until the button is
// hovered, focused or pressed, so a screen reader reaches it through
// aria-describedby and nothing that explains a screen is ever lost to it.

import { useId, useState, type ReactNode } from 'react';
import { useT } from '../i18n/index.tsx';
import { Icon } from './Icon.tsx';

export function InfoTip({ children, label }: { readonly children: ReactNode; readonly label?: string }): ReactNode {
  const t = useT();
  const id = useId();
  const [pinned, setPinned] = useState(false);
  return (
    <span className={`infotip${pinned ? ' open' : ''}`} data-testid="infotip">
      <button
        type="button"
        className="infotip-button"
        aria-label={label ?? t('common.moreInfo')}
        aria-describedby={id}
        aria-expanded={pinned}
        onClick={() => setPinned((open) => !open)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setPinned(false);
        }}
        onBlur={() => setPinned(false)}
      >
        <Icon name="info" size={14} />
      </button>
      <span role="tooltip" id={id} className="infotip-text">
        {children}
      </span>
    </span>
  );
}
